/** @format */
import React, { useEffect, useRef } from 'react';
import {
  Grid,
  useMediaQuery,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Button,
} from '@mui/material';
import { useQuery } from 'hooks';

import {
  PageContainer,
  ButtonLoading,
  TargetUser,
  ConfirmDialog,
  SimpleDialog,
  RadioGroupPod,
  InputV2,
  Icons,
  CustomCaptchaComponent,
} from 'components';

import { useForm, FormProvider } from 'react-hook-form';
import { enifyDateTime } from 'utility';
import IssueInvoiceServices from './services/IssueInvoiceServices';
import { Preview } from './components';
import { IssueInvoicContent, ProfileInvoice } from './components';
import createToast from 'components/Toast/Toast';
import { useTargetUser } from 'hooks';
import jMoment from 'moment-jalaali';
import { useNavigate } from 'react-router-dom';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import { useStyles } from './style';
import { validator } from 'myValidation';
import useCustomHook from './hooks';
import { useCurrencyUnit } from 'hooks';

const IssueInvoice = () => {
  const captchaRef = useRef();
  const classes = useStyles();
  const query = useQuery();
  const currencyText = useCurrencyUnit(false);
  const matches = useMediaQuery('(max-width:600px)');
  const {
    activeStep,
    setActiveStep,
    paymenyTools,
    setPaymentTools,
    showDialog,
    setShowDialog,
    previewLoading,
    setPreviewLoading,
    previewData,
    setPreviewData,
    isOpenPreview,
    setIsOpenPreview,
    selectedProducts,
    setSelectedProducts,
    loadingBlock,
    setLoadingBlock,
    tempFirstFormData,
    setTempFirstFormData,
    loadMembershipoading,
    setLoadMembershipoading,
    loadContractsLoading,
    setLoadContractsLoading,
    loadContractsList,
    setLoadContractsList,
    resultInquery,
    setResultInquery,
    phoneNumber,
    setPhoneNumber,
    loadingField,
    setLoadingField,
    loanUserId,
    setLoanUserId,
    captchaId,
    setCaptchaId,
    voucherHashs,
    setVoucherHashs,
    totalPrice,
    setTotalPrice,
    voucherType,
    setVoucherType,
    enteredCaptcha,
    setEnteredCaptcha,
    loanAgreement,
    setLoanAgreement,
  } = useCustomHook();

  const actionsList = getDynamicObjectAction([
    'invoiceFinancialPage',
    'invoiceFinancialBtn',
    'followersListInvoicesFinancialBtn',
  ]);

  const defaultValues = {
    billNumber: '', // شماره قبض
    deadline: jMoment(new Date()).add(10, 'days'), // تاریخ سر رسید
    guildCode: null, // محل واریز درآمد
    productId: [], // شناسه محصول
    productName: [], // نام محصول
    price: [], // مبلغ
    quantity: [], //  تعداد
    discount: [], // تخفیف
    productDescription: [], // توضیحات محصول
    voucherHashs: [], // بن تخفیف
    preferredTaxRate: 10, // مالیات
    postVoucherEnabled: 'true', // رادیو ا کد تخفیف
    verificationNeeded: 'false', // رادیو نیازمند تایید
    needProfile: 'false', // کلید مربوط به نوع پروفایل
    toolType: 'PAYMENT_TOOL_CHEQUE', // ابزار پرداخت
    payDueDate: null, // تاریخ سر رسید
    payerId: '', // شناسه پرداخت کننده
    amount: 0, // مقدار پروفایل
    amountPercentage: 100, // درصد پروفایل
  };

  const targetUser = useTargetUser();
  const methods = useForm({ defaultValues });
  const { handleSubmit } = methods;
  const navigate = useNavigate();

  useEffect(() => {
    if (paymenyTools === 'IS_LOAN') {
      setLoadContractsLoading(1);
      getLoanContracts();
    } else {
      setLoanAgreement(null);
    }
  }, [paymenyTools]);

  const ActionsFillDataBtn = () => {
    return (
      <>
        <ButtonLoading
          variant="contained"
          type="button"
          color="primary"
          loading={loadMembershipoading}
          name={'عضویت در قرارداد'}
          aria-controls="simple-menu"
          onClick={() => {
            addUserToContract();
          }}
          aria-haspopup="true"
          disabled={loadMembershipoading}
          className={classes.reciveBtn}
        />

        <ButtonLoading
          variant="contained"
          disabled={loadMembershipoading}
          onClick={() => {
            setResultInquery(null);
          }}
          style={{ marginRight: '0' }}
          name={'اصلاح'}
          type="button"
        />
      </>
    );
  };

  const ActionsBtn = () => {
    return (
      <>
        <ButtonLoading
          variant="contained"
          type="button"
          color="primary"
          loading={loadingField}
          name={' استعلام اطلاعات'}
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={() => {
            onEstelamDetails();
          }}
          disabled={loanAgreement === null || enteredCaptcha.length !== 5 || loadingField}
          className={classes.reciveBtn}
        />

        <ButtonLoading
          variant="contained"
          onClick={() => {
            handleCloseDialog();
          }}
          name={'انصراف'}
          disabled={loadingField}
        />
      </>
    );
  };

  const checkSubmit = (submiter) => {
    submiter();
  };

  const getDescriptionText = (product, idAndName) => {
    if (idAndName.id == 0)
      return `${idAndName.name ?? ''}${idAndName.name && product.description ? ' - ' : '_'}${
        product.description ?? ''
      }`;
    return `${product.description ?? '_'}`;
  };

  const getLoanContracts = async () => {
    try {
      let res = await IssueInvoiceServices.getLoanContracts();
      setLoadContractsList(res?.result);
      setShowDialog(true);
    } catch (error) {
      setPaymentTools('NOT_SELECTED');
    } finally {
      setLoadContractsLoading(0);
    }
  };

  const addUserToContract = async () => {
    setLoadMembershipoading(true);
    let data = {
      creditExpireDate: jMoment(loadContractsList[0]?.endDate).locale('en').format('jYYYY/jMM/jDD'),
      cellphoneNumber: phoneNumber,
    };
    try {
      let res = await IssueInvoiceServices.addUserToContract(data, loadContractsList[0].id);
      createToast('موفق', 'با موفقیت انجام شد', 'success');
      setLoanUserId(res?.result);
      setShowDialog(false);
    } catch (error) {
    } finally {
      setLoadMembershipoading(false);
    }
  };

  // سرویس مربوط به پروفایل
  const callProfile = async (id) => {
    const data = methods.getValues();
    let body = {
      partialInvoicePaymentProfileItemVOS: [
        {
          toolType: data?.toolType,
          payDueDate: enifyDateTime(jMoment(new Date())?.format('jYYYY/jMM/jDD HH:mm:ss')),
        },
      ],
    };
    if (data?.payerId?.length === 10) {
      body.partialInvoicePaymentProfileItemVOS[0].payerNationalCode = data?.payerId;
    } else if (data?.payerId?.length === 11) {
      body.partialInvoicePaymentProfileItemVOS[0].payerPhoneNumber = data?.payerId;
    }
    if (voucherType === 'amount') {
      body.partialInvoicePaymentProfileItemVOS[0].amount = totalPrice;
    } else {
      body.partialInvoicePaymentProfileItemVOS[0].amountPercentage = data?.amountPercentage;
    }
    try {
      await IssueInvoiceServices.invoiceProfile(id, body);
      navigate('/Invoice');
      sendSms(id);
    } catch (error) {
    } finally {
    }
  };

  // سرویس مربوط به صدور فاکتور بعد از دیالوگ
  const issueInvoice = async () => {
    checkSubmit(async () => {
      const invoiceBody = getInvoiceBody();
      setLoadingBlock(true);
      try {
        let result = await IssueInvoiceServices.issueInvoice(invoiceBody);
        if (paymenyTools === 'IS_CHEQUE') {
          callProfile(result?.data?.result?.id);
        } else {
          if (loanAgreement?.length > 0) {
            sendSms(result?.data?.result?.id);
          }
          navigate('/Invoice');
        }
      } catch (error) {
      } finally {
        setLoadingBlock(false);
        setIsOpenPreview(false);
      }
    });
  };

  // دیتای نمایش در دیالوگ
  const getInvoiceBody = () => {
    const data = methods.getValues();
    const invoiceBody = {
      userId: query.get('id') ? query.get('id') : targetUser?.userId || loanUserId || null,
      billNumber: data.billNumber ? data.billNumber : tempFirstFormData.billNumber || null, // String
      guildCode: data.guildCode?.code
        ? data.guildCode?.code
        : tempFirstFormData.guildCode?.code ?? null, // String
      deadline: data.deadline ? enifyDateTime(data.deadline?.format('jYYYY/jMM/jDD')) : null, // String
      productId: selectedProducts?.map?.((p) => p.id), // [int]
      price: selectedProducts?.map?.((p) => p.price), // [Positive Number]
      quantity: selectedProducts?.map?.((p) => Number(p.quantity)), // [int]
      discount: selectedProducts?.map?.((p) => (p.discount === '' ? null : Number(p.discount))),
      productDescription: selectedProducts?.map?.((p, k) =>
        getDescriptionText(p, selectedProducts[k]),
      ),
      voucherHash: voucherHashs, // [string]
      preferredTaxRate:
        data.preferredTaxRate === ''
          ? null
          : Number(data.preferredTaxRate) || tempFirstFormData.preferredTaxRate === ''
          ? null
          : Number(tempFirstFormData.preferredTaxRate),
      description: data.description ? data.description : tempFirstFormData?.description || '',
      verificationNeeded:
        data.verificationNeeded !== undefined
          ? data.verificationNeeded
          : tempFirstFormData.verificationNeeded,
      postVoucherEnabled:
        data.postVoucherEnabled !== undefined
          ? data.postVoucherEnabled
          : tempFirstFormData.postVoucherEnabled,
    };
    return invoiceBody;
  };

  // سرویس مربوط به صدور فاکتور جهت نمایش در دیالوگ
  const previewIssueInvoice = async (data) => {
    if (activeStep == 0) {
      setTempFirstFormData(data);
    }

    if (
      activeStep == 0
        ? (data && data?.guildCode === null) || data?.guildCode === undefined
        : tempFirstFormData?.guildCode === null || tempFirstFormData?.guildCode === undefined
    ) {
      //
      createToast('خطا', ' محل واریز درآمد خالی است.', 'danger');
      return;
    }

    if (paymenyTools === 'IS_CHEQUE' && activeStep === 1) {
      if (
        (data?.payerId?.length !== 10 && data?.payerId?.length !== 11) ||
        data?.payerId?.length === 0 ||
        !validator.isNumeric(data?.payerId)
      ) {
        createToast('خطا', 'پرداخت کننده به درستی وارد نشده است.', 'danger');
        return;
      }
      if (!/^(?:\d{10}|\d{11}|\d{0})$/.test(data?.payerId?.toString())) {
        createToast('خطا', 'پرداخت کننده باید یک عدد معتبر باشد.', 'danger');
        return;
      }
    }
    if (paymenyTools === 'IS_CHEQUE' && activeStep === 0) {
      setActiveStep(1);

      return;
    }
    checkSubmit(async () => {
      const invoiceBody = getInvoiceBody();

      setPreviewLoading(true);
      try {
        const res = await IssueInvoiceServices.previewIssueInvoice(invoiceBody);
        setPreviewData(res?.data?.result);
        setIsOpenPreview(true);
      } catch (error) {
      } finally {
        setPreviewLoading(false);
      }
    });
  };

  const sendSms = async (invoiceId) => {
    let body = {
      invoiceId: invoiceId,
      newGateway: true,
    };
    if (loanAgreement !== null) {
      body.isLoan = true;
    }
    createToast('در انتظار', 'در حال ارسال پیامک', 'info');
    try {
      await IssueInvoiceServices.sendInvoicePaymentSms(body);
      createToast('موفق', 'با موفقیت انجام شد', 'success');
    } catch (error) {}
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    setPaymentTools('NOT_SELECTED');
    setTimeout(() => {
      setLoanAgreement(null);
      setLoadContractsList([]);
    }, 100);
  };

  /**
   * استعلام اطلاعات کاربر
   */
  const onEstelamDetails = async () => {
    if (phoneNumber?.length !== 11) {
      createToast('خطا', ' شماره همراه پرداخت کننده معتبر نمی‌باشد.!', 'danger');
      return;
    }
    setLoadingField(true);
    const body = {
      captchaAnswer: enteredCaptcha,
      captchaId: captchaId,
    };

    if (validator.isMobilePhone(phoneNumber ?? '')) {
      body.phoneNumber = phoneNumber;
    } else {
      createToast('خطا', ' شماره همراه پرداخت کننده معتبر نمی‌باشد.!', 'danger');
      captchaRef?.current?.onMakeCaptcha();
      setLoadingField(false);
      return;
    }

    await IssueInvoiceServices.estelamDetails(body)
      .then((res) => {
        setLoadingField(false);
        setResultInquery(res?.result);
      })
      .catch((error) => {
        setLoadingField(false);
        captchaRef?.current?.onMakeCaptcha();
      });
  };

  const hintText =
    'با استفاده از این ابزار می‌توانید فاکتور با مبلغ دلخواه و برای محصول دلخواه صادر کنید.';
  return (
    <PageContainer
      description={hintText}
      title="صدور فاکتور"
      breadcrumbs={constBreadCrumbsTitle.ISSUE_INVOICE}
    >
      {(actionsList['invoiceFinancialPage'] ||
        actionsList['followersListInvoicesFinancialBtn']) && (
        <>
          <TargetUser />
          <FormProvider {...methods}>
            <form
              onSubmit={handleSubmit(previewIssueInvoice)}
              onKeyDown={(e) => {
                if (e.key == 'Enter') {
                  e.preventDefault();
                }
              }}
              noValidate
              autoComplete="off"
            >
              {paymenyTools === 'IS_CHEQUE' && activeStep === 1 ? (
                <ProfileInvoice
                  voucherType={voucherType}
                  setVoucherType={setVoucherType}
                  totalPrice={totalPrice}
                />
              ) : (
                <IssueInvoicContent
                  editData={tempFirstFormData}
                  activeStep={activeStep}
                  setSelectedProducts={setSelectedProducts}
                  setTotalPrice={setTotalPrice}
                  setVoucherHashs={setVoucherHashs}
                  selectedProducts={selectedProducts}
                  voucherHashs={voucherHashs}
                  changeNeedProfile={setPaymentTools}
                  defualPaymentType={paymenyTools}
                  loadContractsLoading={loadContractsLoading}
                />
              )}

              {(activeStep === 1 && paymenyTools === 'IS_CHEQUE') ||
              paymenyTools !== 'IS_CHEQUE' ? (
                <Grid container item justifyContent="flex-end">
                  {paymenyTools === 'IS_CHEQUE' && activeStep === 1 && (
                    <Button
                      variant="outlined"
                      style={{ marginInlineStart: 'auto', marginInlineEnd: 16 }}
                      onClick={() => {
                        setActiveStep(0);
                      }}
                    >
                      مرحله قبل
                    </Button>
                  )}
                  {(actionsList['invoiceFinancialBtn'] ||
                    actionsList['followersListInvoicesFinancialBtn']) && (
                    <ButtonLoading
                      variant="contained"
                      color="primary"
                      loading={previewLoading}
                      name={
                        paymenyTools == 'IS_CHEQUE'
                          ? matches
                            ? 'صدور فاکتور'
                            : 'صدور فاکتور و ایجاد پروفایل'
                          : 'صدور فاکتور'
                      }
                      disabled={!!loadContractsLoading || previewLoading}
                      type="submit"
                    />
                  )}
                </Grid>
              ) : (
                <Grid container item justifyContent="flex-end">
                  <ButtonLoading
                    variant="contained"
                    color="primary"
                    loading={previewLoading}
                    name={'مرحله بعد'}
                    type="submit"
                  />
                </Grid>
              )}
            </form>
          </FormProvider>
        </>
      )}

      <ConfirmDialog
        open={isOpenPreview}
        onClose={() => setIsOpenPreview(false)}
        onConfirm={issueInvoice}
        title="پیش نمایش"
        confirmButtonText="صدور"
        cancelButtonProps="انصراف"
        loading={loadingBlock}
      >
        {currencyText && <Preview data={previewData} currencyText={currencyText} />}
      </ConfirmDialog>

      <SimpleDialog
        fullWidth
        maxWidth="sm"
        open={showDialog}
        icon={<Icons icon="UserIDCard" color="#303d8f" size="25" />}
        title={resultInquery === null ? 'لیست قراردادهای تسهیلاتی' : 'اطلاعات پرداخت کننده'}
        actions={resultInquery !== null ? <ActionsFillDataBtn /> : <ActionsBtn />}
      >
        {resultInquery === null ? (
          <Grid container>
            <Grid item xs={12} className={classes.radios}>
              <RadioGroupPod
                label="در این بخش لیست قراردادهای تسهیلاتی کسب و کار نمایش داده می شود. شما میتوانید از لیست زیر تنها یک قرارداد را جهت استفاده در پرداخت انتخاب نمایید."
                control={methods.control}
                name="loanAgreements"
                defaultValue={loanAgreement}
                onChangeradio={(e) => {
                  setLoanAgreement(e);
                }}
                options={loadContractsList.map((item) => ({
                  value: item.id.toString(),
                  label: `${item.name} (زمان پایان قرارداد : ${jMoment(item?.endDate).format(
                    'jYYYY/jMM/jDD',
                  )})`,
                  placement: 'end',
                }))}
              />
            </Grid>
            {loanAgreement ? (
              <>
                <Grid item xs={12} lg={7} className={classes.phoneNumber}>
                  <InputV2
                    rules={['isNumeric', 'required']}
                    name="phoneNumber"
                    label="شماره همراه پرداخت کننده"
                    fullWidth
                    tooltip="در این قسمت می بایست شماره کاربر پرداخت کننده فاکتور جهت عضویت در قرارداد و امکان پرداخت اقساطی وارد شود."
                    dir="ltr"
                    defaultValues={phoneNumber}
                    forceValue={phoneNumber}
                    placeholder=""
                    onChangeValue={(e) => {
                      setPhoneNumber(e.target.value);
                    }}
                  />
                </Grid>
                <Grid container wrap={matches ? 'wrap' : 'nowrap'}>
                  <InputV2
                    label="کد امنیتی"
                    forceValue={enteredCaptcha}
                    onChangeValue={(e) => {
                      const value = e.target.value;
                      if (value.length > 5) {
                        e.preventDefault();
                        setEnteredCaptcha(value.slice(0, 5));
                      } else {
                        setEnteredCaptcha(value);
                      }
                    }}
                    englishNumber
                    rules={['isNumeric']}
                    fullWidth
                    dir="ltr"
                  />
                  <CustomCaptchaComponent
                    pageTitle="/Delegation - وجه های تفویض شده به من - دیالوگ انتقال به سایرین"
                    ref={captchaRef}
                    setCaptchaId={setCaptchaId}
                    setEnteredCaptcha={setEnteredCaptcha}
                    sizeOptions={{ xs: '12', md: '10', lg: '10' }}
                  />
                </Grid>
              </>
            ) : (
              ''
            )}
          </Grid>
        ) : (
          <Grid container>
            <Grid item xs={12}>
              <TableContainer className={classes.tableContainer}>
                <Table className={classes.table} aria-label="simple table">
                  <TableBody>
                    <TableRow>
                      <TableCell className={classes.titleCell} component="th" scope="row">
                        نام و نام خانوادگی :
                      </TableCell>
                      <TableCell className={classes.titleCellData}>
                        {`${!resultInquery?.given_name && !resultInquery?.family_name ? '-' : ''}${
                          resultInquery?.given_name ?? ''
                        } ${resultInquery?.family_name ?? ''}`}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.titleCell} component="th" scope="row">
                        شماره همراه :
                      </TableCell>
                      <TableCell className={classes.titleCellData}>{phoneNumber}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        )}
      </SimpleDialog>
    </PageContainer>
  );
};

export default IssueInvoice;
